import React from 'react';
import { useTranslation } from 'react-i18next';
import { MessageSquare, Mic, FileText, Share2, Sparkles } from 'lucide-react';
import image1 from '../images/image-1.png';
import image2 from '../images/image-2.png';
import image3 from '../images/image-3.png';
import image4 from '../images/image-4.png';

const FeatureCarousel = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: FileText,
      title: t('features.formattedNotes.title'),
      description: t('features.formattedNotes.description'),
      image: image1,
    },
    {
      icon: Mic,
      title: t('features.transcribe.title'),
      description: t('features.transcribe.description'),
      image: image2,
    },
    {
      icon: MessageSquare,
      title: t('features.chat.title'),
      description: t('features.chat.description'),
      image: image3,
    },
    {
      icon: Share2,
      title: t('features.export.title'),
      description: t('features.export.description'),
      image: image4,
    },
  ];

  return (
    <div className="bg-white py-24 dark:bg-slate-900">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-1.5 rounded-full text-sm font-semibold mb-4">
            <Sparkles className="w-4 h-4" />
            AI-Powered
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 dark:text-white">{t('features.title')}</h2>
          <p className="text-gray-500 max-w-2xl mx-auto dark:text-gray-400">{t('features.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={index} className="bg-gray-50 border border-gray-200 rounded-2xl p-6 dark:bg-slate-800 dark:border-slate-700">
                <div className="bg-primary/10 p-3 rounded-xl inline-block mb-4">
                  <Icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="font-semibold text-lg text-gray-900 mb-2 dark:text-white">{feature.title}</h3>
                <p className="text-gray-500 text-sm dark:text-gray-400">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FeatureCarousel;
